<mat-form-field appearance="fill" class="form-slim w-100">
  <input matInput
         type="text"
         [placeholder]="atCap ? 'Max ' + maxItems() + ' reached' : placeholder()"
         [value]="inputValue()"
         [disabled]="atCap || disabled()"
         (input)="inputValue.set($any($event.target).value)"
         (keydown)="handleKeydown($event)"
         [attr.aria-label]="ariaLabel()" />

  <span matSuffix class="d-flex align-items-center gap-1">
    <span class="mat-font-label-sm" >
      {{ count() }}/{{ maxItems() }}
    </span>
    <button matIconButton
            type="button"
            [attr.aria-label]="ariaLabel()"
            [disabled]="!inputValue().trim() || atCap || disabled()"
            (click)="tryAdd()">
      <mat-icon>add</mat-icon>
    </button>
  </span>
</mat-form-field>
